// @ts-check

import { MapView, Mappedin, getVenue } from "@mappedin/mappedin-js";
import { useEffect, useState } from "react";
import useVenue from "./Mappedin/useVenue";
import useMapView from "./Mappedin/useMapView";
import { createMapCalculations } from "../mapCalculations";



/**
 * @typedef {import("@mappedin/mappedin-js").TShowVenueOptions} TShowVenueOptions
 * @typedef {import("@mappedin/mappedin-js").TGetVenueOptions} TGetVenueOptions
 * 
 */



/////////////////////////////////////////////
// Demo options:
//

// /** 
//  * @type {TGetVenueOptions}
//  */
// const options = {

//   // See Trial API key Terms and Conditions
//   // https://developer.mappedin.com/guides/api-keys

//   // venue: "mappedin-demo-mall",
//   venue: "warehouse-demo",
//   clientId: "5eab30aa91b055001a68e996",
//   clientSecret: "RJyRXKcryCMy4erZqqCbuB1NbR66QTGNXVE0x3Pg6oCIlUR1",


// };




/**
 * @param {React.MutableRefObject<HTMLDivElement | null>} mapHtmlTargetRef
 * @param {any} props
 * 
 * @returns {[Mappedin | undefined, MapView | undefined]}
 */
export default function useInitializeMap(mapHtmlTargetRef, props) {
  // console.log('INIT MAP OUTER ===> ');

  // let sMapSettings = props.sData.get('mapSettings');
  let sActiveMapSetting = props.sData.get('activeMapSetting');
  // console.log('sMapSettings ===> ', sMapSettings);


  /** 
   * @type {[TGetVenueOptions | null, Function]}
  */
  let [mapOptions, setMapOptions] = useState(null);

  ///////////////////////////////////////////
  // Process map settings from server:
  // - Convert to map options and save to local state.
  // - Whenever map options change, update the local state.
  // - useVenue depends on this state and will trigger update.
  //
  processServerMapSettings(sActiveMapSetting, mapOptions, setMapOptions);

  const venue = useVenue(mapOptions);
  const mapView = useMapView(mapHtmlTargetRef.current, venue, {
    
    multiBufferRendering: true,
    outdoorView: {
      enabled: true
    },

    aoEnabled: true,
    aoQuality: "medium",
    aoResolution: "full",
    
    // xRayPath: true,
    
    
  });
  
  /////////////////////////////////////////////////////////////
  // This adds map calculations metadata to the maps objects
  // to be used elsewhere in the app.
  //
  recalculateMapsMetadata(venue);


  return [
    venue,
    mapView
  ];
}



////////////////////////////////////////////////
// Helpers:


/**
 * @param {any} sActiveMapSetting
 * @param {TGetVenueOptions | null} mapOptions
 * @param {any} setMapOptions
 */
function processServerMapSettings(sActiveMapSetting, mapOptions, setMapOptions) {

  let mapOptionsFromServer = convertToMapOptions(sActiveMapSetting);
  let currentSetting = mapOptions;

  if (settingsAreEqual(mapOptionsFromServer, currentSetting)) {
    return;
  }

  setMapOptions(mapOptionsFromServer);
}




/**
 * @param {any} sMapSettingItem
 * 
 * @returns {TGetVenueOptions | null}
 */
function convertToMapOptions(sMapSettingItem) {

  if (!sMapSettingItem) {
    return null;
  }

  let s = {
    clientId: sMapSettingItem.clientId,
    clientSecret: sMapSettingItem.clientSecret,
    venue: sMapSettingItem.venue,
  };

  /** @type {TGetVenueOptions} */
  return s;
}


/**
 * @param {TGetVenueOptions | null} a
 * @param {TGetVenueOptions | null} b
 */
function settingsAreEqual(a, b) {

  if (a === b) {
    return true;
  }

  if (!a) {
    return false;
  }

  if (!b) {
    return false;
  }


  if (a.clientId !== b.clientId) {
    return false;
  }

  if (a.clientSecret !== b.clientSecret) {
    return false;
  }

  if (a.venue !== b.venue) {
    return false;
  }


  return true;
}


/**
 * @param {Mappedin | undefined} venue
 */
function recalculateMapsMetadata(venue) {
  
  if (!venue) {
    return;
  }
  
  
  let maps = venue.maps;
  maps.forEach((map) => {
    
    /** @type {import("../liveMapPageTypes").Pl_Map} */
    let m = map;
    
    let calculations = createMapCalculations(m);
    if (!calculations) {
      return;
    }
    
    if (!m.pl_Metadata) {
      m.pl_Metadata = {};
    }
    m.pl_Metadata.mapCalculations = calculations;
    
  });

}





